import { Navigate, Route, Routes } from "react-router-dom";
import { Dashboard } from "./screens/dashboard/Dashboard";
import { Error404 } from "./screens/404/Error404";
import { BasicSettings } from "./screens/settings/BasicSettings";
import { Designs } from "./screens/libraries/designs/Designs";
import { DesignDetails } from "./screens/libraries/designs/DesignDetails";
import { Alphabets } from "./screens/libraries/fonts/Alphabets";
import { FontDetails } from "./screens/libraries/fonts/FontDetails";
import { ColorCollections } from "./screens/libraries/colorCollections/ColorCollections";
import { ColorCollectionDetails } from "./screens/libraries/colorCollections/ColorCollectionDetails";
import { FontCollections } from "./screens/libraries/fontCollections/FontCollections";
import { FontCollectionDetails } from "./screens/libraries/fontCollections/FontCollectionDetails";
import { InputFormats } from "./screens/inputFormats/InputFormats";
import { InputFormatDetails } from "./screens/inputFormats/InputFormatDetails";
import { DesignMappings } from "./screens/designMappings/DesignMappings";
import { DesignMappingDetails } from "./screens/designMappings/DesignMappingDetails";
import { Logs } from "./screens/logs/Logs";
import { LogDetails } from "./screens/logs/LogDetails";
import { DataMappings } from "./screens/inputFormats/DataMappings";

export const MainContent: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Dashboard />} />

      <Route path="design-mappings">
        <Route path="" element={<DesignMappings />} />
        <Route path=":designMappingId" element={<DesignMappingDetails />} />
      </Route>

      <Route path="input-formats">
        <Route path="" element={<InputFormats />} />
        <Route path=":inputFormatId">
          <Route path="" element={<InputFormatDetails />} />
          <Route path="data-mappings" element={<DataMappings />} />
        </Route>
      </Route>

      <Route path="libraries">
        <Route path="" element={<Navigate to="designs" replace />} />

        <Route path="designs">
          <Route path="" element={<Designs />} />
          <Route path=":designId" element={<DesignDetails />} />
        </Route>

        <Route path="fonts">
          <Route path="" element={<Alphabets />} />
          <Route path=":fontId" element={<FontDetails />} />
        </Route>

        <Route path="font-collections">
          <Route path="" element={<Navigate to="embroidery" replace />} />
          <Route path="embroidery">
            <Route path="" element={<FontCollections />} />
            <Route
              path=":fontCollectionId"
              element={<FontCollectionDetails />}
            />
          </Route>
        </Route>

        <Route path="color-collections">
          <Route path="" element={<Navigate to="embroidery" replace />} />
          <Route path="embroidery">
            <Route path="" element={<ColorCollections />} />
            <Route
              path=":colorCollectionId"
              element={<ColorCollectionDetails />}
            />
          </Route>
        </Route>
      </Route>

      <Route path="settings">
        <Route path="" element={<Navigate to="basic" replace />} />
        <Route path="basic" element={<BasicSettings />} />
      </Route>

      <Route path="logs">
        <Route path="" element={<Logs />} />
        <Route path=":logId" element={<LogDetails />} />
      </Route>

      <Route path="login/support" element={<Navigate to="/" replace />} />

      <Route path="*" element={<Error404 />} />
    </Routes>
  );
};
